import React from "react";
import './styles.css'
import MenuItems from "./MenuItems";
import { useDarkMode } from "src/context/DarkModeContext";
import UserMenu from "./user-menu/UserMenu";
import { Divider } from "antd";

interface MobileMenuProps {
  menuVisible: boolean;
  setMenuVisible: (visible: boolean) => void;
  handleSignOut: () => Promise<void>;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ menuVisible, setMenuVisible, handleSignOut }) => {
  const { isDarkMode } = useDarkMode();
  return (
    <>
      <div className={`overlay ${menuVisible ? "visible" : ""}`} onClick={() => setMenuVisible(false)} />
      <div className={`slide-menu ${menuVisible ? "open" : ""}`}>
        <div className="header">
          <span>Menu</span>
          <span className="close-button" onClick={() => setMenuVisible(false)}>✖</span>
        </div>

        <div className="content">
          <MenuItems isDarkMode={isDarkMode} />
          <Divider style={{ backgroundColor: "#CCDAFF" }} />
          <UserMenu handleSignOut={handleSignOut} isDarkMode={isDarkMode} className="mobile-user-menu" />
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
